module.exports = __webpack_public_path__ + "img/bImg4.bb1c7099.png";